import React from 'react';
import { Link } from 'react-router-dom';
import cn from 'classnames';
import Section from '@components/Section';
import ColorSplotch from '@components/ColorSplotch';
import styles from './Groups.module.scss';
import Contact from '@models/Contact';
import GroupModel from '@models/Group';
import { useSelector } from 'react-redux';
import { groupsForContactSelector } from '@actions/groups';
import { useTheme } from '@support/hooks/use-theme';
import { StarredIcon } from '@components/Icons';

export function GroupPill({ group, asLink = true }: { group: GroupModel; asLink?: boolean }) {
  const [theme] = useTheme();
  const isStarred = group.slug === 'starred';
  let borderColor = group.color;
  let icon = <ColorSplotch className={styles.color} color={group.color} />;

  if (isStarred) {
    borderColor = theme === 'light' ? '#FFD700' : '#fff';
    icon = <StarredIcon className={styles.starredIcon} isLight={theme === 'light'} />;
  }

  const pillContent = (
    <>
      <span className={styles.border} style={{ borderColor }} />
      {icon}
      <span className="text-small">{group.title}</span>
    </>
  );

  if (asLink) {
    return (
      <Link
        className={cn(styles.item, isStarred && styles.starred)}
        to={`/group/${group.slug || group.id}`}
      >
        {pillContent}
      </Link>
    );
  } else {
    return <div className={styles.item}>{pillContent}</div>;
  }
}

export default function Groups({
  contact,
  underline = true,
}: {
  contact: Contact;
  underline?: boolean;
}) {
  const groupsForContact = useSelector(groupsForContactSelector(contact.id));

  return groupsForContact.length > 0 ? (
    <Section>
      <Section.Title underline={underline}>Groups</Section.Title>
      <div className={styles.items}>
        {groupsForContact.map((group) => (
          <GroupPill group={group} key={group.id} />
        ))}
      </div>
    </Section>
  ) : null;
}
